import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskNotificationsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-notifications',
	path: '/jira/servicedesk/projects/:projectKey/settings/notifications',
	exact: true,
};
